
















import CtrlSearchCommonComponents from '@/components/common/control/CtrlSearchCommonComponents.vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'ListItakusaki',
  components: {
    CtrlSearchCommonComponents,
  },
  props: {
    haisoKaishaCd: {
      type: Number,
      required: true,
    },
    mukoUmuFlg: {
      type: Number,
    },
  },
  data: () => ({
    headers: [
      {
        text: 'コード',
        sortable: true,
        value: 'itakusakiCd',
        width: 80,
      },
      {
        text: '名称',
        sortable: true,
        value: 'itakusakiRyakuMei',
        width: 340,
      },
    ],
    formatColName: 'itakusakiCd',
  }),
});
